/* eslint-disable react/prop-types */
import { motion } from 'framer-motion';
import { observer } from "mobx-react";

const VariationToggle = observer(({
  product,
  selectedVariation,
  setSelectedVariation,
}) => {

  return (
    <div className="variation-toggle w-full md:w-auto p-0 pt-0 md:p-5 md:pt-0 md:pb-6">
      <div className="toggle-wrapper flex-1 cursor-pointer items-center overflow-hidden rounded-xl font-semibold bg-gray-100">
        {product.variations.filter(variation => variation.status === 'publish').map((variation) => (
          <motion.button
            key={variation.id}
            className={`w-2/4 px-1 text-xs py-1.5 transition duration-300 rounded-xl
              ${selectedVariation?.id === variation.id
                ? 'bg-primary-light-studio text-primary-studio'
                : 'text-gray-800'
              }`}
            onClick={() => setSelectedVariation(variation)}
            initial={{
              opacity: 0.5,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{ duration: 0.3 }}
          >
            {variation?.attributes?.map(attr => decodeURIComponent(attr.option)).join(' / ')}
          </motion.button>
        ))}
      </div>
    </div>
  );
});

export default VariationToggle;
